module.exports = new __parcel__URL__("caution.cf189b14.png").toString();